import { useContext, useState } from "react";
import LogoComponent from "../../components/Logos/LogoComponent";
import BackButton from "../../components/buttons/BackButton";
import { isMobilePhone } from "validator";
import SubmitButton from "../../components/buttons/SubmitButton";
import { CurrentUserContext } from "../../App";
import { useNavigate } from "react-router-dom";
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3080";

export default function MobileVerificationPage() {
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);
  const [mobile, setMobile] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [mobileError, setMobileError] = useState("");
  const navigate = useNavigate();

  const handlePhoneNumberChange = (e) => {
    let inputPhoneNumber = e.target.value;
    inputPhoneNumber = inputPhoneNumber.replace(/\D/g, "");
    setMobile(inputPhoneNumber);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setMobileError("");

    const fullMobile = `${countryCode}${mobile}`;
    const phoneNumber = parsePhoneNumberFromString(fullMobile);

    if (phoneNumber && isMobilePhone(fullMobile)) {
      fetch(`${API_URL}/sendMobileOtp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${currentUser?.token}`,
        },
        body: JSON.stringify({ mobile: phoneNumber.format('E.164') }),
      })
        .then((r) => r.json())
        .then((r) => {
          if (r.message === "Verification SMS sent successfully") {
            setCurrentUser({
              ...currentUser,
              mobile: phoneNumber.format('E.164'),
            });
            localStorage.setItem(
              "currentUser",
              JSON.stringify({
                ...currentUser,
                mobile: phoneNumber.format('E.164'),
              })
            );
            navigate("/login/enterotp");
          } else {
            alert(r.message);
          }
        });
    } else {
      setMobileError("Please enter a valid phone number");
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100 justify-content-center align-items-center">
      <div style={{ maxWidth: "30rem" }}>
        <div className="mb-4">
          <LogoComponent />
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center text-start gap-2">
          <div className="mb-3 me-auto">
            <div className="me-auto mb-4">
              <BackButton />
            </div>
            <div className="lh-sm mb-4">
              <span className="main-purple fw-bold" style={{ fontSize: "2.4rem" }}>
                Enter your
              </span>
              <br />
              <span className="main-purple fw-bold" style={{ fontSize: "2.4rem" }}>
                mobile number
              </span>
            </div>
            <p className="mb-4" style={{ fontSize: "1.2rem" }}>
              We will send you a confirmation code
            </p>
          </div>
          <form onSubmit={handleFormSubmit} noValidate>
            <div className="row mb-2">
              <div className="col-3">
                <select
                  className="otp-input form-select rounded-3 p-3"
                  style={{
                    fontSize: "1.6rem",
                    backgroundColor: "var(--main-background)",
                    color: "var(--main-white)",
                  }}
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                >
                  <option value="+1">+1</option>
                  <option value="+91">+91</option>
                </select>
              </div>
              <div className="col-9">
                <input
                  type="text"
                  className="otp-input rounded-3 p-3 text-center form-control"
                  placeholder="Enter your mobile number"
                  value={mobile}
                  onChange={handlePhoneNumberChange}
                  maxLength={10}
                />
              </div>
            </div>
            <label className="errorLabel">
              {mobileError}
            </label>
            <div>
              <SubmitButton
                className="btn fw-bold bg-main-purple"
                buttonText={"Send Code"}
                buttonValue={"sendOTP"}
              />
            </div>
          </form>
          <button
            type="button"
            className="btn btn-link text-decoration-none mt-2"
            style={{ color: "var(--main-purple)", fontSize: "1.2rem" }}
            onClick={() => navigate("/login/selectAvatar")}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}
